function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { useCallback } from 'react';
import { ChartUtils } from '@deephaven/chart';
import { assertIsDashboardPluginProps, LayoutUtils, useListener } from '@deephaven/dashboard';
import { nanoid } from 'nanoid';
import { IrisGridEvent } from "./events/index.js";
import { ChartPanel } from "./panels/index.js";
/**
 * Listens for IrisGridEvent.CREATE_CHART and creates a chart from the settings provided
 * Requires the GridPlugin and ChartPlugin plugins to be loaded as well
 */
export function ChartBuilderPlugin(props) {
  assertIsDashboardPluginProps(props);
  var id = props.id,
    layout = props.layout;
  var handleCreateChart = useCallback(_ref => {
    var metadata = _ref.metadata,
      _ref$panelId = _ref.panelId,
      panelId = _ref$panelId === void 0 ? nanoid() : _ref$panelId,
      table = _ref.table;
    var settings = metadata.settings;
    var fetchTable = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        return table;
      });
      return function fetchTable() {
        return _ref2.apply(this, arguments);
      };
    }();
    var title = ChartUtils.titleFromSettings(settings);
    var config = {
      type: 'react-component',
      component: ChartPanel.COMPONENT,
      props: {
        localDashboardId: id,
        id: panelId,
        metadata,
        fetch: fetchTable
      },
      title,
      id: panelId
    };
    var root = layout.root;
    LayoutUtils.openComponent({
      root,
      config
    });
  }, [id, layout]);
  useListener(layout.eventHub, IrisGridEvent.CREATE_CHART, handleCreateChart);
  return null;
}
export default ChartBuilderPlugin;
//# sourceMappingURL=ChartBuilderPlugin.js.map